import {Component} from '@angular/core';

@Component({
    selector: 'dmp-asterisk',
    template: `<span>&#42;</span>`,
    styles: [],
    standalone: false
})
export class AsteriskComponent {


}
